<myqq-default-layout pageTitle="Welcome">
  <ng-container
    [ngSwitch]="currentStep$ | async"
    class="fls-2-1 fld-col ai-ctr vwc-p100 vwcmx-rem0"
  >
    <ng-container *ngSwitchCase="steps.enter_credit_card_details">
      <myqq-locate-membership
        [currentStep]="currentStep$ | async"
        (changeLocateStep)="gotoStep($event)"
      >
      </myqq-locate-membership>
      <myqq-lookup-account-credit-card
        (submitToken)="searchForPaymentMethod($event)"
        (cancel)="startOver()"
        (error)="handleLookupError($event)"
      ></myqq-lookup-account-credit-card>
    </ng-container>

    <ng-container *ngSwitchCase="steps.last4lookup">
      <myqq-locate-membership
        [currentStep]="currentStep$ | async"
        (changeLocateStep)="gotoStep($event)"
      >
      </myqq-locate-membership>
      <myqq-last4lookup
        (submitLast4Lookup)="last4Lookup($event)"
        (skip)="startOver()"
      >
      </myqq-last4lookup>
    </ng-container>

    <ng-container
      *ngSwitchCase="steps.confirm_account"
      [useDatumEither]="accountLookup$ | async"
    >
      <myqq-loading *onInitial>
        <h3>Initializing...</h3>
      </myqq-loading>

      <myqq-loading *onPending>
        <h3>Searching for Account...</h3>
      </myqq-loading>

      <myqq-account-setup-failed *onFailure (restart)="handleHasAccount(true)">
      </myqq-account-setup-failed>

      <ng-container
        *onSuccess="let accountCheck"
        [ngSwitch]="accountCheck.type"
      >
        <myqq-confirm-account-linking
          *ngSwitchCase="'found_one_no_link'"
          [vehicles]="accountCheck.membership?.vehicles"
          [washLevelName]="accountCheck.stripeSubscription?.myQQShortDisplayName"
          (userDeclinesLink)="handleHasAccount()"
          (userConfirmsLink)="handleConfirmAccountLink(accountCheck.membership?.account)"
        ></myqq-confirm-account-linking>
        <myqq-account-setup-failed
          *ngSwitchDefault
          (restart)="handleHasAccount(true)"
        >
        </myqq-account-setup-failed>
      </ng-container>
    </ng-container>

    <ng-container
      *ngSwitchCase="steps.complete"
      [useDatumEither]="linkAccount$ | async"
    >
      <myqq-loading *onInitial>
        <h3>Initializing...</h3>
      </myqq-loading>

      <myqq-loading *onPending>
        <h3>Saving Account...</h3>
      </myqq-loading>

      <myqq-error
        *onFailure="let error; let loading= refreshing"
        title="Account Setup Error"
        description="There was an error saving your account details."
        [error]="error"
      >
        <footer class="qq-buttons">
          <button
            myqq-button
            aria-label="Retry"
            class="raised"
            color="primary"
            [disabled]="loading"
            (click)="startOver()"
            (keyup.enter)="startOver()"
            (keydown.enter)="$event.preventDefault()"
          >
            {{ loading ? "Refreshing..." : "Retry" }}
          </button>
        </footer>
      </myqq-error>

      <myqq-account-setup-complete *onSuccess></myqq-account-setup-complete>
    </ng-container>

    <myqq-account-setup-failed
      *ngSwitchCase="steps.failed"
      [message]="mustLink ? emailAlreadyOnMembershipMessage.prefix +
      emailAlreadyOnMembershipMessage.message :
      newAccountSetUpFailureMessage"
      [buttonText]="'Link Account'"
      (restart)="mustLink? gotoStep(steps.last4lookup) :
      startOver()"
    ></myqq-account-setup-failed>
    <ng-container *ngSwitchCase="steps.enter_account_details">
      <ng-container *ngTemplateOutlet="enteraccountdetails"></ng-container>
    </ng-container>

    <ng-container
      *ngSwitchCase="steps.choose_location"
      [useDatumEither]="regions$ | async"
    >
      <myqq-loading *onInitial>
        <h3>Initializing...</h3>
      </myqq-loading>

      <myqq-loading *onPending>
        <h3>Getting data…</h3>
      </myqq-loading>

      <myqq-error
        *onFailure="let error; let loading= refreshing"
        title="Store Lookup Error"
        description="There was an error retrieving store locations."
        [error]="error"
      >
        <footer>
          <button
            myqq-button
            class="raised"
            aria-label="Retry"
            color="primary"
            [disabled]="loading"
            (click)="startOver()"
            (keyup.enter)="startOver()"
            (keydown.enter)="$event.preventDefault()"
          >
            {{ loading ? "Refreshing..." : "Retry" }}
          </button>
        </footer>
      </myqq-error>

      <myqq-choose-account-location
        *onSuccess="let regions"
        [regions]="regions"
        [pendingAccount]="pendingAccount"
        (back)="gotoStep(steps.enter_account_details)"
        (saveProfile)="createNewAccount($event)"
      ></myqq-choose-account-location>
    </ng-container>

    <div *ngSwitchDefault class="fld-col flg-5 pwt-4 ai-stc pwa-5">
      <h2 class="ta-c">Step Not Implemented</h2>
      <footer>
        <button
          myqq-button
          class="raised"
          aria-label="Start over"
          (click)="gotoStep(steps.enter_account_details)"
          (keyup.enter)="gotoStep(steps.enter_account_details)"
          (keydown.enter)="$event.preventDefault()"
          color="primary"
        >
          Start Over
        </button>
      </footer>
    </div>
  </ng-container>
</myqq-default-layout>

<ng-template #enteraccountdetails>
  <ng-container [useDatumEither]="profileData$ | async">
    <myqq-loading *onInitial>
      <h3>Initializing...</h3>
    </myqq-loading>

    <myqq-loading *onPending>
      <h3>Getting data…</h3>
    </myqq-loading>

    <myqq-error
      *onFailure="let error; let refreshing= refreshing"
      title="Account Setup Error"
      description="There was an error saving your account details."
      [error]="error"
    >
      <footer>
        <button
          myqq-button
          class="raised"
          color="primary"
          aria-label="Start over"
          [disabled]="refreshing"
          (click)="retryRegionalData()"
          (keyup.enter)="retryRegionalData()"
          (keydown.enter)="$event.preventDefault()"
        >
          {{ refreshing ? "Refreshing..." : "Start Over" }}
        </button>
      </footer>
    </myqq-error>
    <myqq-enter-account-details
      *onSuccess="let data"
      [profileData]="data.profile"
      [account]="pendingAccount"
      [zipcode]="(salesPipeline$ | async)?.zipcode"
      (saveProfile)="createNewAccount($event)"
      (hasMembership)="handleHasAccount()"
      (restart)="startOver()"
    ></myqq-enter-account-details>
  </ng-container>
</ng-template>
